import Vue from "vue";
import App from "./App.vue";
import router from "./Router";
import store from "./Store";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "normalize.css";

Vue.use(ElementUI);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
